import { render, staticRenderFns } from "./OnGoing.vue?vue&type=template&id=bbad53e2&scoped=true&"
import script from "./OnGoing.vue?vue&type=script&lang=js&"
export * from "./OnGoing.vue?vue&type=script&lang=js&"
import style0 from "./OnGoing.vue?vue&type=style&index=0&id=bbad53e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbad53e2",
  null
  
)

component.options.__file = "OnGoing.vue"
export default component.exports